import { EditorToolbar } from "./EditorToolbar.tsx";
import { MachineCanvas } from "./MachineCanvas.tsx";
import { PropertiesPanel } from "./PropertiesPanel.tsx";
import { ProposalPanel } from "./ProposalPanel.tsx";

/**
 * Root of the in-app machine editor. Replaces the old read-only `StateView`
 * (xyflow click-to-GOTO of the hardcoded six-state machine) with a full editor:
 * toolbar (top), AI proposal panel (when present), xyflow canvas (center),
 * properties panel (right).
 *
 * All state lives in the @xstate/store; this component is a pure layout shell.
 */
export function MachineEditor() {
  return (
    <div className="w-full h-full flex flex-col bg-[#14161a]">
      <EditorToolbar />
      <ProposalPanel />
      <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-[1fr_280px]">
        <MachineCanvas />
        <PropertiesPanel />
      </div>
    </div>
  );
}
